import ReactDOM from "react-dom";
import Raven from "raven-js";
import MobileDetect from "mobile-detect";

import routes from "./routes";

if (window && window.navigator) {
  window.MobileDetect = new MobileDetect(window.navigator.userAgent);
}

if (process.env.NODE_ENV !== "development") {
  Raven.config("https://206589049b7541ac877bcd8cf298cf55@sentry.io/198375", {
    captureUnhandledRejections: true
  }).install();
}

ReactDOM.render(routes, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js